import { Check, CircleDashed, Loader2, XCircle } from "lucide-react";
import { cn } from "~/lib/utils";
import type { TaskInstanceState } from "~/services/dagRuns";
import { taskStateBucket } from "./dagTaskGroups";

// Uses the shared `taskStateBucket` classifier, so this can't drift out of
// sync with the task list's count-breakdown label. The success badge matches
// SessionContextIngestDetail's StepDot for a consistent look across panels.
export const TaskInstanceStateIconMap = (
  state: TaskInstanceState | null,
  className?: string
): React.ReactNode => {
  switch (taskStateBucket(state)) {
    case "success":
      return (
        <span
          className={cn(
            "flex items-center justify-center rounded-full bg-green-600 text-white dark:bg-green-500",
            className
          )}
        >
          <Check className="size-2.5" aria-hidden />
        </span>
      );
    case "running":
      return <Loader2 className={cn("animate-spin text-primary", className)} aria-hidden />;
    case "failed":
      return <XCircle className={cn("text-destructive", className)} aria-hidden />;
    case "retrying":
      return <CircleDashed className={cn("text-yellow-600", className)} aria-hidden />;
    case "pending":
      return <CircleDashed className={cn("text-muted-foreground", className)} aria-hidden />;
  }
};
